import { Snackbar, SnackbarCloseReason } from '@mui/material';
import { closeSnackbar } from './snackbarSlice';
import Alert from '@mui/material/Alert';
import './SnackbarProvider.css';
import { useAppSelector, useAppDispatch } from '../../shared/redux/store';
import React from 'react';

const SnackbarProvider = () => {
  const state = useAppSelector((state) => state.snackbar);
  const dispatch = useAppDispatch();

  const handleClose = (e:Event | React.SyntheticEvent<Element, Event>, reason:SnackbarCloseReason) => {
    if (reason !== 'clickaway') {
      dispatch(closeSnackbar());
    }
  };

  return (
    <Snackbar
      className="SnackbarProvider"
      open={state.open}
      onClose={handleClose}
      autoHideDuration={state.duration}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}>
      <Alert
        elevation={6}
        variant="filled"
        severity={state.severity}
        onClose={handleClose as (event: React.SyntheticEvent<Element, Event>) => void}
      >
        {state.message}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarProvider;
